import axios from '@/axios';

const itemsBasePath = process.env.VUE_APP_ITEMS_ENDPOINT;

export default {
    fetchAllCombos() {
        return axios.get(`${itemsBasePath}/combos`);
    },
    fetchAllMenuItems() {
        return axios.get(`${itemsBasePath}/menu-items`);
    }
}
